module.exports = __webpack_public_path__ + "img/logo-w-text@2x.ddaa3bb.png";